import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import { Form, Row, Col, Button, Container } from 'react-bootstrap';
import { Modal, ModalManager, Effect } from 'react-dynamic-modal';
import { useHistory } from 'react-router-dom';
import http from '../../../services/Api';
import swal from 'sweetalert';

import { RiLoader4Line } from 'react-icons/ri';

import './index.css'

function EditBeaconModal({ mac, beaconName }) {
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit } = useForm();
    const body = document.getElementsByTagName('body')[0];

    const closeModal = () => {
        ModalManager.close();
        body.style.overflow = 'auto'
    }

    const style = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 99999999,
            overflowX: 'hidden',
            overflowY: 'auto',
            perspective: 1300,
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },

        content: {
            position: 'relative',
            border: '1px solid rgba(0, 0, 0, .2)',
            width: 'inherit',
            background: '#fff',
            overflow: 'auto',
            borderRadius: '4px',
            outline: 'none',
            boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
        }
    }

    const handleSave = async data => {
        const { name } = data
        try {
            const response = await http.post(`/api/devices/update-name/${mac}`, {
                name
            });

            setLoading(false);
            ModalManager.close();
            body.style.overflow = 'auto'

            swal("Nome alterado com Sucesso!", {
                title: "Sucesso!",
                icon: "success",
            })

            return response.data;

        } catch (e) {
            console.log(e);
            setLoading(false);

            ModalManager.close();
            body.style.overflow = 'auto'
            swal("Erro!", "Não foi possível alterar o nome", "error");
            return null;
        }
    }

    return (
        <div className="EditBeaconModal customMargin">
            <Modal
                style={style}
                onRequestClose={() => { }}
                effect={Effect.Fall}>
                <Container fluid>
                    <div className="header">
                        <div className="title">
                            Alterar nome do Dispositivo
                    </div>
                    </div>
                    <div className="body">
                        <Form method="POST" onSubmit={handleSubmit(handleSave)}>
                            <Form.Group as={Row} className="customForm">
                                <Form.Label column sm="2" >
                                    Nome
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        ref={register}
                                        placeholder="Digite o nome do beacon"
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Button variant="primary" className="customBtn" type="submit" sm6>
                                    {
                                        loading ? (<RiLoader4Line className="spin" />) : 'Salvar'
                                    }
                                </Button>
                                <Button variant="primary" className="customBtn" sm6 onClick={closeModal}>
                                    {
                                        loading ? (<RiLoader4Line className="spin" />) : 'Cancelar'
                                    }
                                </Button>
                            </Form.Group>
                        </Form>
                    </div>
                </Container>
            </Modal>
        </div>
    );
}

export default EditBeaconModal;